import { PhoneType } from "../../../types";
import {
  BasicAccountApplicationDocument,
  PostAddress,
} from "../../../api/commercial/generated-types";

export enum ResidencePermit {
  B = "B",
  C = "C",
  OTHER = "OTHER",
}

export enum AnnualGrossIncome {
  LESS_THAN_50_000 = "LESS_THAN_50_000",
  BETWEEN_50_000_AND_100_0000 = "BETWEEN_50_000_AND_100_0000",
  BETWEEN_100_000_AND_150_0000 = "BETWEEN_100_000_AND_150_0000",
  OVER_150_000 = "OVER_150_000",
}

export interface CardholderModel {
  nationality: string;
  birthdate: string;
  gender: string;
  firstName: string;
  lastName: string;
  fullStreet: string;
  address: PostAddress;
  phoneBusiness: PhoneType;
  mobile: PhoneType;
  emailBusiness: string;
  correspondenceLanguage: string;
  companyPosition: string;
  isCurrentPermanentEmployee: string;
  spendingLimit?: number;
  spendingLimitOther?: string;
  annualGrossIncome?: AnnualGrossIncome;
  residencePermit?: ResidencePermit;
  isCrossBorderWorker?: string;
}

export interface FundsOwnershipCardholderModel {
  nationality: string;
  birthdate: string;
  gender: string;
  firstName: string;
  lastName: string;
  fullStreet: string;
  address: PostAddress;
}

export interface CardholderFormProps extends CardholderModel {
  isSameAsAdmin?: boolean;
  selectedProduct: string;
  isSoleProprietorship: boolean;
  hasDecentralizedInvoicing: BasicAccountApplicationDocument["hasDecentralizedInvoicing"];
}
